/* 订单接口 */
import http from '@/utils/http'
import config from '@/config/config'

const api = {
  genOrder: '/api/genOrder',
  payOrder: '/api/payOrder',
  getOrder: '/api/getOrder',
  getOrderList: '/api/getOrderList',
}

/**
 * 生成订单
 * @export
 * @param {string} token
 * @param {string} goodsId 商品id
 * @param {string} orderPrice 订单价格（单位是分）
 * @param {string} shareId 分销邀请人uid
 * @returns
 */
export function genOrder(token, goodsId, orderPrice, shareId = '') {
  return http.get(api.genOrder, {
    token: token,
    good_id: goodsId,
    order_price: orderPrice,
    share_id: shareId,
  })
}

/**
 * 支付订单，返回支付链接
 * @export
 * @param {number} orderId 订单号
 * @param {string='alipay','wechatpay'} payment 支付方式
 * @param {string} [backUrl] 支付回调地址(传入时不用编码)
 * @param {string} [extra] 他人代付时传字符串 third，否则不传值
 * @returns
 */
export function payOrder(orderId, payment, backUrl = location.href, extra = '') {
  if (extra == 'third') extra = '{"pay":"otherperson"}' // 他人代付
  return http.get(api.payOrder, {
    order_id: orderId,
    payWay: config.payment[payment],
    extra: extra,
    backUrl: backUrl
  })
}

/**
 * 获取订单信息
 * @export
 * @param {*} orderId 订单id
 * @returns
 */
export function getOrder(orderId) {
  return http.get(api.getOrder, {
    order_id: orderId
  })
}

/**
 * 获取订单列表
 * @export
 * @param {*} token 
 * @param {number} [limit=30] 
 */
export function getOrderList(token, limit = 30) {
  return http.get(api.getOrderList, {
    token: token,
    limit: limit,
  })
}
